import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const projectsSteps = (ctx: TourStepContext): StepType[] => {
  const steps: StepType[] = [
    {
      selector: '[data-testid="project-search-input"]',
      content:
        'Use o campo de busca para encontrar projetos pelo nome, código ou responsável.',
    },
    {
      selector: '[data-testid="status-filter-green"]',
      content:
        'Filtre projetos por status de saúde: Verde (no prazo), Amarelo (atenção) ou Vermelho (crítico). Clique em múltiplos para combinar filtros.',
    },
    {
      selector: '[data-testid="project-priority-filter"]',
      content: 'Filtre por prioridade (Alta, Média, Baixa) para focar nos projetos mais relevantes.',
    },
    {
      selector: '.projects-page__table',
      content:
        'A tabela lista todos os projetos com status, progresso, prazo e responsável. Clique em qualquer linha para abrir o detalhe do projeto.',
    },
  ];

  if (!ctx.isMobile) {
    steps.splice(3, 0, {
      selector: '[data-testid="project-create-btn"]',
      content:
        'Clique aqui para cadastrar um novo projeto. Você será direcionado ao formulário completo de criação.',
    });
  }

  if (!ctx.isMobile && ctx.hasPermission('admin')) {
    steps.splice(4, 0, {
      selector: '[data-testid="project-roadmap-btn"]',
      content:
        'Visualize todos os projetos em um Roadmap de linha do tempo para ter uma visão estratégica do portfólio.',
    });
  }

  return steps;
};
